import { render, staticRenderFns } from "./CommentsListView.vue?vue&type=template&id=2fb38810"
import script from "./CommentsListView.vue?vue&type=script&lang=js"
export * from "./CommentsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports